import { observer, pr, React, RouteComponentProps, theme, ui } from "aaa";
import { NativePaper } from "components/common/NativePaper";
import { SigningComponentWrapper, SigningHeaderBackground } from "components/signing/views/SigningComponent";
import { TopBackgroundColor } from "components/util/TopBackgroundColor";
import * as QRCode from "qrcode.react";
import { pushRoute } from "stores/RouterFunctions";
import { CancelButton } from "../../util/CancelButton";
import { SIdentitySettingsStore } from "./SIdentitySettingsStore";
import { SIdentitySettingsRoutes } from "./SIdentitySettingsRoutes";

type IProps = RouteComponentProps<{}> & {
    store: SIdentitySettingsStore;
};

@observer
export class SIdentitySettingsCode extends React.Component<IProps, {}> {
    renderOverlayBox = () => {
        return (
            <NativePaper
                style={{
                    margin: "20px 10px",
                    borderRadius: theme.BORDER_RADIUS,
                    textAlign: "left",
                    overflow: "hidden",
                    position: "relative",
                    background: "white",
                    zIndex: 1
                }}
            >
                <pr.SigningLabelContainer>
                    <pr.P_14_CONTENT>
                        {ui.__("sidentity.code.info")}
                    </pr.P_14_CONTENT>

                    <pr.HCenterDiv
                        style={{ marginTop: 32, marginBottom: 8 }}
                        aria-label={ui.__("common.qrcode")}
                        role="img"
                    >
                        <QRCode
                            value={this.props.store.activationCode}
                        />
                    </pr.HCenterDiv>

                    <pr.P_16_TITLE style={{ textAlign: "center", padding: 10, color: theme.themeColors.blue_400 }}>
                        {this.props.store.activationCodeFormatted}
                    </pr.P_16_TITLE>
                </pr.SigningLabelContainer>

            </NativePaper>
        );
    }

    render() {
        return (
            <SigningComponentWrapper className="theme-landing-background-color">
                <TopBackgroundColor />
                <CancelButton
                    showRight
                    onClick={async () => {
                        await this.props.store.loadSIdSettingsDevices();
                        pushRoute(SIdentitySettingsRoutes.ROOT);
                    }}
                />
                <SigningHeaderBackground />

                <pr.H1WithFocus
                    style={{
                        ...pr.STYLE_SEMI_24_WHITE,
                        position: "relative",
                        marginTop: 20
                    }}
                >
                    {ui.__("common.activationCode")}
                </pr.H1WithFocus>

                {this.renderOverlayBox()}

                <pr.P_14_CONTENT
                    style={{
                        margin: "0px 20px",
                        paddingBottom: 20,
                        textAlign: "left",
                    }}
                >
                    {ui.__("sidentity.code.scan.info")}
                </pr.P_14_CONTENT>

            </SigningComponentWrapper >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/sIdentitySettings/SIdentitySettingsCode.tsx